import React from 'react';
import './DisplayServices.css';
import { useHistory } from 'react-router';

const DisplayServices = (props) => {
    const { _id, title, description, img } = props.service
    const history = useHistory();
    const handleClick = () => {
        history.push(`/serviceDetails/${_id}`);

    }
    return (
        <div style={{ padding: "0", textAlign: "justify", borderRadius: "20px", width: "560px" }} class="card mb-3"  >
            <div class="row  g-0" >
                <div class="col-md-6" style={{ borderRadius: "20px" }} >
                    <img src={img} style={{ borderRadius: "20px" }} class="img-fluid" alt="..." />
                </div>
                <div class="col-md-6">
                    <div class="card-body">
                        <h5 class="card-title">{title}</h5>
                        <p class="card-text">{description}</p>
                        <button className="btn btn-danger" onClick={handleClick}>See Details</button>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default DisplayServices;






{/* <div class="card mb-3" style="max-width: 540px;">
  <div class="row g-0">
    <div class="col-md-4">
      <img src="..." class="img-fluid rounded-start" alt="...">
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">Card title</h5>
        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
      </div>
    </div>
  </div>
</div> */}



{/* <div className="col displayService">
            <div className="card mx-auto" style={{ width: "18rem" }}>
                <img src={img} className="card-img-top" alt="..." height="200px" />
                <div className="card-body">
                    <h5 className="card-title"> {title}</h5>
                    <p style={{ textAlign: "justify" }} className="card-text">{description}</p>
                    <button className="btn btn-danger" onClick={handleClick}>See Details</button>
                </div>
            </div>

        </div> */}